// extracted by mini-css-extract-plugin
export default {"modal_select__list":"ModalSelectList-module__modal_select__list--NPhrN","modal_select__item":"ModalSelectList-module__modal_select__item--YySGF"};